export const LOADING_SIZE = 30;

export const BUTTON_LOADING = 'buttonLoading';
